import { Locale } from '@ha/intl';

export function getDisplayNames(locale: Locale) {
  const displayNames = Intl.DisplayNames
    ? new Intl.DisplayNames(locale, { type: 'region' })
    : // eslint-disable-next-line @typescript-eslint/no-unused-vars
      { of: (_code: string) => '' };
  return displayNames;
}
